import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";
import Wordmark from "./Wordmark";
import { tokens } from "../theme";
import { INQUIRY_EMAIL, INSTAGRAM_URL } from "../auth";

const linkSx = {
  textDecoration: "none",
  color: tokens.taupe,
  fontSize: "0.78rem",
  letterSpacing: "0.14em",
  textTransform: "uppercase" as const,
  fontWeight: 600,
  "&:hover": { color: tokens.ink },
};

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        borderTop: `1px solid ${tokens.line}`,
        mt: { xs: 8, md: 14 },
        py: { xs: 5, md: 7 },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            alignItems: { md: "center" },
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Wordmark size={22} />
            <Typography sx={{ mt: 1, fontSize: "0.85rem", maxWidth: 320 }}>
              Original paintings and small works. Each piece is one of a kind.
            </Typography>
          </Box>
          <Box
            sx={{ display: "flex", gap: { xs: 3, md: 4 }, flexWrap: "wrap" }}
          >
            <Box component={RouterLink} to="/works" sx={linkSx}>
              Works
            </Box>
            <Box component={RouterLink} to="/collections" sx={linkSx}>
              Collections
            </Box>
            <Box component={RouterLink} to="/about" sx={linkSx}>
              About
            </Box>
            <Box
              component="a"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={linkSx}
            >
              Instagram
            </Box>
            <Box component="a" href={`mailto:${INQUIRY_EMAIL}`} sx={linkSx}>
              Inquire
            </Box>
          </Box>
        </Box>
        <Typography
          sx={{
            mt: { xs: 4, md: 6 },
            fontSize: "0.72rem",
            color: tokens.taupe,
            letterSpacing: "0.04em",
          }}
        >
          © {new Date().getFullYear()} TLArt. All works © the artist.
        </Typography>
      </Container>
    </Box>
  );
}
